import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

interface LoadingProps {
  $isLoading: boolean;
}

function displayLoading({ $isLoading }: LoadingProps) {
  return $isLoading ? 'flex' : 'none';
}

export const StyledButtonLoading = styled.div<LoadingProps>`
  && {
    position: absolute;
    inset: 0;
    display: ${displayLoading};
    align-items: center;
    justify-content: center;
    height: auto;
    padding: 0;
    pointer-events: none;
  }
`;

export const StyledButtonLoadingSpinner = styled.div`
  && {
    width: 1rem;
    height: 1rem;
    padding: 0;
    border: 2px solid transparent;
    border-top-color: currentcolor;
    border-right-color: currentcolor;
    border-radius: 50%;
    animation: ${rotate} 0.7s linear infinite;
  }
`;
